import { render, staticRenderFns } from "./ArtPage2.vue?vue&type=template&id=371ddfc6&scoped=true"
import script from "./ArtPage2.vue?vue&type=script&lang=js"
export * from "./ArtPage2.vue?vue&type=script&lang=js"
import style0 from "./ArtPage2.vue?vue&type=style&index=0&id=371ddfc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371ddfc6",
  null
  
)

export default component.exports